__turbopack_context__.v({
  "callBtn": "pu1qaq_callBtn",
  "christmasBranch": "pu1qaq_christmasBranch",
  "fixed": "pu1qaq_fixed",
  "header": "pu1qaq_header",
  "headerButtons": "pu1qaq_headerButtons",
  "headerCenter": "pu1qaq_headerCenter",
  "headerLeft": "pu1qaq_headerLeft",
  "headerLogo": "pu1qaq_headerLogo",
  "headerLogoLink": "pu1qaq_headerLogoLink",
  "headerPhone": "pu1qaq_headerPhone",
  "headerRight": "pu1qaq_headerRight",
  "icicles": "pu1qaq_icicles",
  "iconCloseBurger": "pu1qaq_iconCloseBurger",
  "isNavigationOpen": "pu1qaq_isNavigationOpen",
  "isVisible": "pu1qaq_isVisible",
  "mobileMenu": "pu1qaq_mobileMenu",
  "mobileMenuButton": "pu1qaq_mobileMenuButton",
  "showHeaderFixed": "pu1qaq_showHeaderFixed",
  "unfixed": "pu1qaq_unfixed",
});
